import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/fleet/vehicle-ownerships')({
  component: lazyRouteComponent(() => import('&/features/settings/fleet/pages/vehicle-ownerships-page')),
  staticData: { titleKey: 'vehicleOwnerships' },
});
